/**
 * Map mã định danh model của Apple (ProductName, vd "iPhone10,3") -> tên thương mại
 * ("iPhone X"). Apple KHÔNG trả tên thương mại qua MDM, phải tra bảng.
 * Bổ sung model mới khi Apple ra máy đời sau.
 */
const MODELS = {
  // iPhone 6s → SE1
  'iPhone8,1': 'iPhone 6s', 'iPhone8,2': 'iPhone 6s Plus', 'iPhone8,4': 'iPhone SE (2016)',
  // iPhone 7
  'iPhone9,1': 'iPhone 7', 'iPhone9,3': 'iPhone 7', 'iPhone9,2': 'iPhone 7 Plus', 'iPhone9,4': 'iPhone 7 Plus',
  // iPhone 8 / X
  'iPhone10,1': 'iPhone 8', 'iPhone10,4': 'iPhone 8', 'iPhone10,2': 'iPhone 8 Plus', 'iPhone10,5': 'iPhone 8 Plus',
  'iPhone10,3': 'iPhone X', 'iPhone10,6': 'iPhone X',
  // iPhone XS / XR
  'iPhone11,2': 'iPhone XS', 'iPhone11,4': 'iPhone XS Max', 'iPhone11,6': 'iPhone XS Max', 'iPhone11,8': 'iPhone XR',
  // iPhone 11 / SE2
  'iPhone12,1': 'iPhone 11', 'iPhone12,3': 'iPhone 11 Pro', 'iPhone12,5': 'iPhone 11 Pro Max', 'iPhone12,8': 'iPhone SE (2020)',
  // iPhone 12
  'iPhone13,1': 'iPhone 12 mini', 'iPhone13,2': 'iPhone 12', 'iPhone13,3': 'iPhone 12 Pro', 'iPhone13,4': 'iPhone 12 Pro Max',
  // iPhone 13 / SE3
  'iPhone14,4': 'iPhone 13 mini', 'iPhone14,5': 'iPhone 13', 'iPhone14,2': 'iPhone 13 Pro', 'iPhone14,3': 'iPhone 13 Pro Max',
  'iPhone14,6': 'iPhone SE (2022)',
  // iPhone 14
  'iPhone14,7': 'iPhone 14', 'iPhone14,8': 'iPhone 14 Plus', 'iPhone15,2': 'iPhone 14 Pro', 'iPhone15,3': 'iPhone 14 Pro Max',
  // iPhone 15
  'iPhone15,4': 'iPhone 15', 'iPhone15,5': 'iPhone 15 Plus', 'iPhone16,1': 'iPhone 15 Pro', 'iPhone16,2': 'iPhone 15 Pro Max',
  // iPhone 16
  'iPhone17,3': 'iPhone 16', 'iPhone17,4': 'iPhone 16 Plus', 'iPhone17,1': 'iPhone 16 Pro', 'iPhone17,2': 'iPhone 16 Pro Max',
  'iPhone17,5': 'iPhone 16e',
};

// appleModelName: trả tên thương mại từ ProductName. Nếu chưa có trong bảng, thử dùng
// ModelName (fallback) nếu nó đã là tên thật (không phải dạng "iPhoneX,Y" hay chung chung).
export function appleModelName(product, fallback) {
  if (product && MODELS[product]) return MODELS[product];
  if (fallback && !/,\d+$/.test(fallback) && !['iPhone', 'iPad', 'iPod'].includes(fallback)) return fallback;
  return '';
}

// appleDeviceImage: URL ảnh sản phẩm CHÍNH CHỦ của Apple — đúng ảnh mà Apple Business
// Manager / Find My hiển thị — tra theo ProductName (vd "iPhone13,1"). Ảnh PNG nền trong
// suốt, MÀU MẶC ĐỊNH của dòng máy: MDM không cho biết màu thật của từng máy nên ảnh chỉ
// khớp tới DÒNG MÁY, không khớp màu. Trả '' nếu ProductName không hợp lệ (vd iPad, rỗng)
// -> FE tự fallback về ô xám / 📱. Ảnh lấy trực tiếp từ CDN Apple (cần Internet ở trình
// duyệt admin — luôn có). Nếu link lỗi, <img onError> cũng fallback về ô xám.
export function appleDeviceImage(product) {
  if (!product || !/^iPhone\d+,\d+$/.test(product)) return '';
  return `https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/${product}/online-infobox__2x.png`;
}
